import type { CSSProperties } from 'react';
import type { Components } from 'react-markdown';
import Markdown from 'react-markdown';

import { cn } from '@/lib/utils';

import propTermsOfService from './legal/prop-terms-of-service.md?raw';
import migrationTerms from './legal/migration-terms.md?raw';

type OrderedListStyle = CSSProperties & {
  '--legal-list-start': number;
};

const components: Components = {
  p: ({ className, node: _node, ...props }) => (
    <p {...props} className={cn('mb-4', className)} />
  ),
  ol: ({ className, node: _node, start, style, ...props }) => (
    <ol
      {...props}
      start={start}
      style={
        {
          ...style,
          '--legal-list-start': (start ?? 1) - 1,
        } as OrderedListStyle
      }
      className={cn('legal-ordered-list pl-4', className)}
    />
  ),
  li: ({ className, node: _node, ...props }) => (
    <li {...props} className={className} />
  ),
};

const migrationComponents: Components = {
  ...components,
  h2: ({ className, node: _node, ...props }) => (
    <h2
      {...props}
      className={cn('mb-4 text-lg font-semibold text-foreground', className)}
    />
  ),
  ul: ({ className, node: _node, ...props }) => (
    <ul {...props} className={cn('mb-4 flex flex-col gap-2 pl-4', className)} />
  ),
};

type WrapperProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

export function PropTradingTermsOfService({
  withTitle,
  ...props
}: WrapperProps & { withTitle?: boolean }) {
  return (
    <div {...props}>
      {withTitle && (
        <h1 className="mb-6 text-xl font-bold">
          VEST PROP TRADING
          <br />
          TERMS OF SERVICE
        </h1>
      )}
      <Markdown components={components}>{propTermsOfService}</Markdown>
    </div>
  );
}

export function MigrationTerms(props: WrapperProps) {
  return (
    <div {...props}>
      <Markdown components={migrationComponents}>{migrationTerms}</Markdown>
    </div>
  );
}
